import { useAppSelector } from '@/redux/store'
import { bingoConfig } from '../const/bingoConfigs'
import { selectBingoRoundBallsCount } from '../redux/bingo.slice'

export function useBingoExtraBallWarning() {
  const ballCount = useAppSelector(selectBingoRoundBallsCount)
  return ballCount == bingoConfig.mining.balls
}
